import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LayoutService } from './services/layout.service';
import { MenudropdownDirective } from './directives/menudropdown.directive';
import { AuthGuard } from './services/other-services/route-guards/auth-guard.service';
import { AuthServiceService } from './services/auth-service.service';
import { MessagingService } from './services/other-services/messaging.service';
import { OthersService } from './services/other-services/others.service';
import { AdminGuard } from './services/other-services/route-guards/admin-guard.service';
import { AreaGuard } from './services/other-services/route-guards/area-guard.service';
import { OfficerGuard } from './services/other-services/route-guards/officer-guard.service';
import { CentralGuard } from './services/other-services/route-guards/central-guard.service';
import { TownGuard } from './services/other-services/route-guards/town-guard.service';
import { StManagerGuard } from './services/other-services/route-guards/stmanager-guard.service';
import { ComprehessiveResolver } from './resolvers/central-dasboard/comprehessive-report.resolver';
import { TransactionApprovalsResolver } from './resolvers/central-dasboard/transaction-approvals.resolver';
import { CreationApprovalsResolver } from './resolvers/central-dasboard/creationApprovals.resolver';
import { ProductPipe } from './pipes/product/product.pipe';
import { BodaChairmenComponent } from './components/boda-chairmen/boda-chairmen.component';
import { BodaClustersComponent } from './components/boda-clusters/boda-clusters.component';
import { BodaStagesComponent } from './components/boda-stages/boda-stages.component';
import { ClientReportComponent } from './components/client-report/client-report.component';
import { CommissionComponent } from './components/commission/commission.component';
import { FloatComponent } from './components/float/float.component';
import { FloatPerDayComponent } from './components/float-per-day/float-per-day.component';
import { LedgerComponent } from './components/ledger/ledger.component';
import { LoanGurantorComponent } from './components/loan-gurantor/loan-gurantor.component';
import { LoanInterestComponent } from './components/loan-interest/loan-interest.component';
import { LoanPrincipalComponent } from './components/loan-principal/loan-principal.component';
import { LoanReportComponent } from './components/loan-report/loan-report.component';
import { LoanSecurityComponent } from './components/loan-security/loan-security.component';
import { LostRevenueComponent } from './components/lost-revenue/lost-revenue.component';
import { RevenueLedgerComponent } from './components/revenue-ledger/revenue-ledger.component';
import { ReversedInterestComponent } from './components/reversed-interest/reversed-interest.component';
import { ReversedPrincipalComponent } from './components/reversed-principal/reversed-principal.component';
import { SavingsComponent } from './components/savings/savings.component';
import { TaxiChairmenComponent } from './components/taxi-chairmen/taxi-chairmen.component';
import { TaxiParksComponent } from './components/taxi-parks/taxi-parks.component';
import { TaxiStagesComponent } from './components/taxi-stages/taxi-stages.component';
import { WaivedInterestComponent } from './components/waived-interest/waived-interest.component';
import { WaivedPrincipalComponent } from './components/waived-principal/waived-principal.component';
import { ClientsReportDirective } from './directives/clients-report.directive';
import { UsersReportComponent } from './components/users-report/users-report.component';
import { StagesComponent } from './components/dashboard/stages/stages.component';
import { ProductsComponent } from './components/dashboard/products/products.component';
import { AmortizationScheduleComponent } from './components/amortization-schedule/amortization-schedule.component';
import { MyLoaderComponent } from './components/my-loader/my-loader.component';
import { LoaderService } from "./services/other-services/loader.service";
import { ExportBtnComponent } from './components/export-btn/export-btn.component';
import { SearchComponent } from './components/search/search.component';
import { LoanPaymentComponent } from './components/loan-payment/loan-payment.component';
import { AccrualInterestComponent } from './components/accrual-interest/accrual-interest.component';
import { DataModalComponent } from './components/data-modal/data-modal.component';
import { ModalModule } from 'ngx-bootstrap/modal';
import { NgxPaginationModule } from "ngx-pagination";
import { StatementModalComponent } from './components/statement-modal/statement-modal.component';


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ModalModule.forRoot(),
    NgxPaginationModule,
  ],
  declarations: [
    MenudropdownDirective,
    ClientsReportDirective,
    ProductPipe,
    WaivedPrincipalComponent,
    WaivedInterestComponent,
    TaxiStagesComponent,
    TaxiParksComponent,
    TaxiChairmenComponent,
    SavingsComponent,
    ReversedPrincipalComponent,
    ReversedInterestComponent,
    RevenueLedgerComponent,
    LostRevenueComponent,
    LoanSecurityComponent,
    LoanReportComponent,
    LoanPrincipalComponent,
    LoanInterestComponent,
    LoanGurantorComponent,
    LedgerComponent,
    FloatPerDayComponent,
    FloatComponent,
    CommissionComponent,
    ClientReportComponent,
    BodaStagesComponent,
    BodaClustersComponent,
    BodaChairmenComponent,
    UsersReportComponent,
    StagesComponent,
    ProductsComponent,
    AmortizationScheduleComponent,
    MyLoaderComponent,
    ExportBtnComponent,
    SearchComponent,
    LoanPaymentComponent,
    AccrualInterestComponent,
    DataModalComponent,
    StatementModalComponent
  ],
  exports: [
    FormsModule,
    MenudropdownDirective,
    ClientsReportDirective,
    WaivedPrincipalComponent,
    WaivedInterestComponent,
    TaxiStagesComponent,
    TaxiParksComponent,
    TaxiChairmenComponent,
    SavingsComponent,
    ReversedPrincipalComponent,
    ReversedInterestComponent,
    RevenueLedgerComponent,
    LostRevenueComponent,
    LoanSecurityComponent,
    LoanReportComponent,
    LoanPrincipalComponent,
    LoanInterestComponent,
    LoanGurantorComponent,
    LedgerComponent,
    FloatPerDayComponent,
    FloatComponent,
    CommissionComponent,
    ClientReportComponent,
    BodaStagesComponent,
    BodaClustersComponent,
    BodaChairmenComponent,
    UsersReportComponent,
    StagesComponent,
    ProductsComponent,
    AmortizationScheduleComponent,
    MyLoaderComponent,
    ExportBtnComponent,
    SearchComponent,
    LoanPaymentComponent,
    AccrualInterestComponent,
    DataModalComponent,
    StatementModalComponent
  ],
})
export class SharedModule {
  static forRoot(): ModuleWithProviders<SharedModule> {
    return {
      ngModule: SharedModule,
      providers: [
        LayoutService,
        AuthServiceService,
        MessagingService,
        OthersService,
        AuthGuard,
        AdminGuard,
        CentralGuard,
        AreaGuard,
        TownGuard,
        StManagerGuard,
        OfficerGuard,
        ComprehessiveResolver,
        TransactionApprovalsResolver,
        ProductPipe,
        CreationApprovalsResolver,
        LoaderService,
      ]
    };
  }
}
